import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/heals_color.png'
import _imports_1 from '@/assets/checkpointLogo.png'
import _imports_2 from '@/assets/docnetLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-1829f3a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-about-us" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "关于我们"),
  /*#__PURE__*/_createElementVNode("p", null, " 要有效地管理所有与个人健康相关的事情并不容易，有些人甚至需要兼顾家人的健康。Heals就是考虑到这一点，于是致力研究一个新方案，希望能够彻底打破健康管理保健界的传统。通过区块链技术，我们打破了传统的健康管理观念，简化繁复的程序，减少你的烦恼。 "),
  /*#__PURE__*/_createElementVNode("p", null, "  "),
  /*#__PURE__*/_createElementVNode("p", null, " 以下三项程式形成一个互相协调的生态系统，让处理健康管理交易的过程更顺畅、安全又可靠。传统医疗保健系统的管理过程从此得以优化。 "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "heals logo"
      })
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        alt: "heals logo"
      })
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        alt: "heals logo"
      })
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}